import { render } from "./index.vue?vue&type=template&id=e1b9c5e6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e1b9c5e6&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1b9c5e6"],['__file',"src/vab/components/VabFooter/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1b9c5e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1b9c5e6', __exports__)) {
    console.log('reload')
    api.reload('e1b9c5e6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=e1b9c5e6&scoped=true", () => {
    console.log('re-render')
    api.rerender('e1b9c5e6', render)
  })

}


export default __exports__